// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"9779af71","990":"3ff8cbd3"}[chunkId] + ".chunk.js";
};